import * as React from 'react';

import Template16 from './Template16';

export const template16 = () => <Template16 />;

export default {
    title: 'Icon/Line/Template16',
    component: Template16,
    parameters: {
        notes: "`import Template16 from 'box-ui-elements/es/icon/line/Template16';`",
    },
};
